import { useFlags } from 'launchdarkly-react-client-sdk';

type CopilotFeatureFlags = {
    isNewCommStyleSmartReplyEnabled: boolean;
    isCampaignSetupV2Enabled: boolean;
    isUnrepliedTabDismissButtonEnabled: boolean;
    isRichTextEditorEnabled: boolean;
    isNewCampaignCreationEndpointEnabled: boolean;
    isNewCampaignMessagingEnabled: boolean;
    isAiMessageEditEnabled: boolean;
    isReplyRecommendationsEnabled: boolean;
    isAiMessageSequenceGenEnabled: boolean;
    isReplyRecommendationOptionsEnabled: boolean;
    isAutoReplyBetaV1Enabled: boolean;
    isCampaignLaunchCheckListEnabled: boolean;
    isAutoReplyConnectionGatingEnabled: boolean;
    isCampaignStrategyEnabled: boolean;
    isAiAudienceSettingsEnabled: boolean;
};

/**
 * Hook to get the feature flags
 * @returns an object with the feature flags
 */
export function useFeatureFlags() {
    const flags = useFlags<CopilotFeatureFlags>();

    return {
        ...flags,
    };
}
